import api, {apiSetup} from '../api';

apiSetup();

export class CodesService {
    BASE_URL = '/projects/codes';

    get() {
        return api.get(this.BASE_URL);
    }
}
